export const PHOTOS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'town',
    label: 'Población',
  },
  {
    field: 'photoUrl',
    label: 'Foto',
    sortable: false,
  },
];
